import { useEffect, useState } from 'react'

import styles from './styles.module.css'

import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from "react-router-dom";

import moment from 'moment';
import { authApi } from '../../services/api/api';
import useAuth from '../../hooks/useAuth';

import { toast, } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import Dialog from '@mui/material/Dialog';
import {  CalendarMonthOutlined, EventAvailableOutlined, Favorite, FavoriteBorder } from '@mui/icons-material';
import { FastAverageColor } from 'fast-average-color';
import { NotebookPen, X } from 'lucide-react';
import AdicionarLivro from '../../pages/adicionarLivro';
import { Zoom } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function Book({ data, index }: any) {
    const api = authApi()
    const { user } = useAuth()
    const navigate = useNavigate()
    const queryClient = useQueryClient(); // <-- ADICIONE ESTA LINHA
    // Estados de Controle
    const [open1, setOpen1] = useState(false);
    const [isReserving, setIsReserving] = useState(false);
    const [likes, setLike] = useState(data?.like ? true : false)
    const [rating, setRating] = useState(data?.rating)
    const [gradientColor, setGradientColor] = useState('transparent');
    const [openEdit, setOpenEdit] = useState(false);
    const [selectedBook, setSelectedBook] = useState(null);


    const themeMui = useTheme();

    const isMobile = useMediaQuery(themeMui.breakpoints.down('sm'));
    // Datas da Reserva
    const start = moment().format('YYYY-MM-DD')
    const end = moment().add(30, 'days').format('YYYY-MM-DD')

    // Funções de Ação
    const handleClickOpen1 = () => setOpen1(true);
    const handleClose1 = () => {
        setOpen1(false);
        setIsReserving(false);
    };
    async function handleSelect() {
        if (!user) return;

        // Criamos um ID único para o toast de carregamento
        const toastId = toast.loading("Processando sua reserva...", { theme: 'dark' });

        try {
            const response = await api.selectBook(data.id, user.id);
            console.log("RESPOSTA DA API:", response);

            if (response === 200 || response === 201) {
                // 1. Notificação de Sucesso
                toast.update(toastId, {
                    render: "Livro reservado com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000
                });

                // 2. Fechar o modal imediatamente para evitar cliques duplos
                handleClose1();

                // 3. O SEGREDO: Em vez de apenas navegar, vamos forçar a atualização
                // Se você estiver usando React Query (TanStack), o ideal é dar um invalidateQueries
                // Mas se quiser apenas ver o resultado, aguardamos a notificação e redirecionamos
                setTimeout(() => {
                    navigate('/dashboard', { state: { refetch: true } });
                    // Se estiver na mesma página e quiser atualizar os dados sem F5:
                    // window.location.reload(); // (Opção radical, mas eficaz para sincronizar status)
                }, 1500);

            } else if (response === 419) {
                toast.update(toastId, {
                    render: "Você já possui uma reserva ativa deste livro.",
                    type: "error",
                    isLoading: false,
                    autoClose: 3000
                });
            } else {
                throw new Error();
            }
        } catch (error) {
            toast.update(toastId, {
                render: "Erro ao reservar. Tente novamente.",
                type: "error",
                isLoading: false,
                autoClose: 3000
            });
        }
    }


    const handleEditOpen = (book: any) => {
        setSelectedBook(book);
        setOpenEdit(true);
    };


    async function handleLike() {
        if (user) {
            const response = await api.likeBook(data.id, user.id)
            if (response == 200) {
                setLike(true)
                setRating((old) => old + 1)
            } else {
                setLike(false)
                setRating((old) => old - 1)
            }
        }
    }

    const handleIndication = () => navigate('/indicacao', { state: data });
    const handleUpdateBook = () => navigate('/adicionar-livro', { state: data });

    // Lógica de Cor Dinâmica
    useEffect(() => {
        const imageUrl = data?.img;
        const fac = new FastAverageColor();
        if (imageUrl) {
            fac.getColorAsync(imageUrl)
                .then(color => {
                    const mainColor = color.hex;
                    const darkColor = darkenHexColor(mainColor, -0.3);
                    setGradientColor(`linear-gradient(to bottom, ${mainColor}, ${darkColor})`);
                })
                .catch(() => setGradientColor('transparent'));
        }
    }, [data?.img]);

    function darkenHexColor(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        let rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    }

    // console.log(data)
    return (
        <div style={{ fontFamily: 'Montserrat' }} className={`flex flex-col justify-center items-center `}>

            {/* ADICIONADO: classe 'group' aqui para monitorar o hover neste container */}
            <div className={`group flex flex-col w-full dark:bg-[#0d2d5f]/30 relative rounded-[10px] transition-all border dark:border-slate-700 duration-300 hover:shadow-2xl overflow-hidden shadow-lg ${styles.fadeIn}`} style={{
                animationDelay: `${(index % 16) * 0.05}s`
            }}>

                {/* Área da Capa com Efeito de Profundidade */}
                <div className="flex flex-col justify-center items-center w-full z-20 p-5 pb-7" style={{
                    background: gradientColor,
                }}>
                    <div className="relative flex justify-center items-center sm:m-auto duration-500 group-hover:scale-105" >
                        {/* Sombra lateral para simular volume do livro */}
                        <img
                            src={data?.img ?? ""}
                            alt="Capa do livro"
                            className="cursor-pointer xs:w-32 rounded-sm shadow-[8px_10px_15px_-3px_rgba(0,0,0,0.4),2px_0_5px_rgba(0,0,0,0.1)] active:scale-95 transition-transform"
                            onClick={handleClickOpen1}
                        />
                    </div>
                </div>

                {/* Rodapé com Efeito Blur (Mistura com o gradiente de fundo) */}
                <div className="mt-auto dark:bg-[#2d3d5780] text-start p-3 bg-white  dark:border-slate-700 backdrop-blur-md flex flex-col justify-center border-t border-white/20">
                    <h4 className="font-bold text-slate-800 dark:text-white capitalize truncate text-sm leading-tight mb-0.5" title={data?.title}>
                        {data?.title ?? ""}
                    </h4>
                    <p className="capitalize text-slate-500  dark:text-slate-400 truncate text-[11px] font-medium tracking-wide">
                        {data?.autor ?? ""}
                    </p>
                </div>


                {/* Container dos Botões de Ação com Overlay */}
                <div className='absolute top-0 left-0 w-full overflow-hidden rounded-t-[10px] z-50 '>
                    <div className={`
                            flex items-center justify-between px-2 py-3 
                            /* Efeito de Vidro Adaptativo */
                            bg-white/20 dark:bg-black/20 backdrop-blur-md 
                            border-b border-white/30
                            /* Animação de Entrada (Deslize e Opacidade) */
                            transition-all duration-500 ease-out
                            opacity-0 -translate-y-full 
                            group-hover:opacity-100 group-hover:translate-y-0
                       `}>

                        {/* Status de Disponibilidade (Badge Estilo Pílula) */}
                        <div className="flex justify-between items-center gap-2 w-full">
                            <div className="">
                                {data?.free_exemplaries?.length > 0 ? (
                                    <span className="inline-flex items-center bg-[#103E89]/90 text-white text-[8px] font-semibold px-2.5 py-1 rounded-full uppercase tracking-tighter shadow-sm">
                                        Disponível
                                    </span>
                                ) : (
                                    <span className="inline-flex items-center bg-rose-500/90 text-white text-[8px] font-bold px-2.5 py-1 rounded-full uppercase tracking-tighter shadow-sm">
                                        Indisponível
                                    </span>
                                )}
                            </div>

                            {/* Grupo de Ações (Like e Admin) */}
                            <div className={`flex items-center gap-2  `}>
                                {/* Botão Curtir com Contador Flutuante */}
                                <button
                                    onClick={handleLike}
                                    className='group/heart relative flex items-center justify-center w-8 h-8 rounded-full bg-white/90 shadow-md hover:bg-white transition-all active:scale-90'
                                >
                                    <span className={`${likes ? 'text-red-500' : 'text-gray-400'} group-hover/heart:text-red-500 transition-colors`}>
                                        {likes ? <Favorite sx={{ fontSize: 17 }} /> : <FavoriteBorder sx={{ fontSize: 17 }} />}
                                    </span>

                                    {rating > 0 && (
                                        <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-semibold w-5 h-5 flex items-center justify-center rounded-full border-2 border-white animate-in zoom-in">
                                            {rating}
                                        </span>
                                    )}
                                </button>

                                {/* Botão Editar (Apenas Admin) */}
                                {user.admin === 1 && (
                                    <button
                                        className='p-2 rounded-full bg-blue-600 text-white shadow-md hover:bg-blue-700 transition-colors active:scale-90'
                                        onClick={() => handleEditOpen(data)}
                                        title="Editar Livro"
                                    >
                                        <NotebookPen size={17} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                TransitionComponent={Zoom}
                maxWidth="md"
                disableScrollLock
                fullScreen={isMobile}
                PaperProps={{
                    style: {
                        borderRadius: isMobile ? 0 : '24px',
                        backgroundImage: 'none',
                        overflow: 'hidden' // Garante que o header não vaze o border-radius
                    },
                }}
            >
                {/* HEADER ESTILIZADO (Padrão das outras telas) */}
                <div className="bg-gradient-to-r from-blue3 to-blue4 px-8 py-6 flex justify-between items-center shadow-lg relative z-10">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-3 rounded-2xl backdrop-blur-md border border-white/20 text-white">
                            <NotebookPen size={17} />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-white tracking-tight leading-none">
                                Editar Exemplar
                            </h2>
                            <p className="text-blue-100 text-[10px] uppercase tracking-[0.2em] font-bold mt-1.5 opacity-70">
                                Gestão de Acervo Digital
                            </p>
                        </div>
                    </div>

                    <button
                        onClick={() => setOpenEdit(false)}
                        className="p-2 rounded-full hover:bg-white/10 text-white/50 hover:text-white transition-all active:scale-90 absolute right-2 top-2"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* CONTEÚDO DO FORMULÁRIO */}
                <div className="xs:p-4 md:p-8 md:max-h-[80vh] max-w-none overflow-y-auto custom-scrollbar">


                    <AdicionarLivro
                        bookData={selectedBook} // Passa os dados para o formulário
                        onSuccess={() => {      // Função disparada após o save com sucesso
                            setOpenEdit(false);
                            // Invalida a cache para atualizar o card na hora sem F5
                            queryClient.invalidateQueries({ queryKey: ['books'] });
                            toast.success("Livro atualizado com sucesso!");
                        }}
                    />
                </div>
            </Dialog>


            <Dialog
                open={open1}
                onClose={handleClose1}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: { borderRadius: 28, overflow: 'hidden', backgroundColor: 'transparent', margin: '16px' }
                }}
            >
                <div className="flex flex-col md:flex-row h-full md:min-h-[500px] md:max-h-[700px] bg-white dark:bg-slate-900 transition-all duration-500 overflow-hidden">

                    {/* COLUNA ESQUERDA: Capa + Metadados (Mobile: Row | Desktop: Column) */}
                    <button onClick={handleClose1} className="absolute top-2 right-2 z-50 p-2 text-slate-400 hover:text-slate-600 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <div className="relative p-6 md:p-10 flex flex-row md:flex-col items-center justify-center gap-6 transition-all duration-500" style={{ background: gradientColor }}>

                        {/* Badge de Disponibilidade */}
                        <div className="absolute top-4 left-4 z-20">
                            <span className={`px-3 py-1 rounded-full text-[9px] font-bold uppercase tracking-widest shadow-lg ${data?.free_exemplaries?.length > 0 ? 'bg-blue-600 text-white' : 'bg-rose-600 text-white'}`}>
                                {data?.free_exemplaries?.length > 0 ? 'Disponível' : 'Indisponível'}
                            </span>
                        </div>

                        {/* Foto do Livro */}
                        <img
                            src={data?.img ?? ""}
                            className="w-28 md:w-44 shadow-[0_20px_50px_rgba(0,0,0,0.3)] rounded-lg transform transition-transform duration-500 z-10"
                            alt="Capa"
                        />

                        {/* Metadados Laterais Refinados (Mobile) */}
                        <div className="flex flex-col justify-between py-1  md:hidden border-l border-white/20 pl-4">

                            {/* Bloco Likes */}
                            <div className="flex flex-col pb-2">
                                <p className="text-[9px] text-white/80 font-bold uppercase tracking-[0.2em] mb-0.5">Likes</p>
                                <div className="flex items-center gap-1.5">
                                    <Favorite className="text-red-500" sx={{ fontSize: 14 }} />
                                    <span className="font-bold text-white text-xs">{rating}</span>
                                </div>
                            </div>

                            {/* Bloco Categoria */}
                            <div className="flex flex-col border-y border-white/10 py-2">
                                <p className="text-[9px] text-white/80 font-bold uppercase tracking-[0.2em] mb-0.5">Categoria</p>
                                <p className="font-bold text-white text-[11px] leading-tight truncate max-w-[100px]">
                                    {data.gen || 'Geral'}
                                </p>
                            </div>

                            {/* Bloco Editora */}
                            <div className="flex flex-col pt-2">
                                <p className="text-[9px] text-white/80 font-bold uppercase tracking-[0.2em] mb-0.5">Editora</p>
                                <p className="font-bold text-[11px] text-white capitalize leading-tight truncate max-w-[100px]">
                                    {data.editora}
                                </p>
                            </div>
                        </div>
                    </div>


                    {/* COLUNA DIREITA: Conteúdo */}
                    <div className="flex-1 flex flex-col relative overflow-hidden bg-white dark:bg-slate-900">

                        {/* Botão de Fechar */}

                        {!isReserving ? (
                            /* --- VISTA 1: DETALHES DO LIVRO --- */
                            <div className="flex flex-col h-full overflow-hidden">

                                {/* Área de Scroll (Título + Sinopse) */}
                                <div className="flex-1 overflow-y-auto p-8 md:p-12 pb-24 custom-scrollbar">
                                    <div className="mb-6">
                                        <h2 className="text-xl md:text-3xl font-black text-slate-800 dark:text-white leading-tight mb-1">{data?.title ?? ""}</h2>
                                        <p className="text-[#103E89] font-bold tracking-widest uppercase text-xs">{data?.autor ?? ""}</p>
                                    </div>

                                    {/* Metadados em Linha (Somente Desktop) */}
                                    <div className="hidden md:flex gap-8 mb-6 py-4 border-y border-gray-100 dark:border-slate-800">
                                        <div className="text-center">
                                            <p className="text-[9px] text-gray-400 font-black uppercase mb-1">Likes</p>
                                            <div className="flex items-center gap-1 font-bold text-slate-700 dark:text-slate-200 text-xs">
                                                <Favorite className="text-red-500" sx={{ fontSize: 16 }} /> {rating}
                                            </div>
                                        </div>
                                        <div className="text-center border-x border-gray-100 dark:border-slate-800 px-8">
                                            <p className="text-[9px] text-gray-400 font-black uppercase mb-1">Categoria</p>
                                            <span className="font-bold text-slate-700 dark:text-slate-200 text-xs">{data.gen || 'Geral'}</span>
                                        </div>
                                        <div className="text-center">
                                            <p className="text-[10px] text-gray-400 font-black uppercase mb-1">Editora</p>
                                            <span className="font-bold text-xs text-slate-700 dark:text-slate-200 capitalize">{data.editora}</span>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <h4 className="text-xs font-bold uppercase text-slate-400 mb-2">Sinopse</h4>
                                        <p className="xs:text-xs md:text-base text-slate-600 dark:text-slate-400 leading-relaxed text-justify italic">
                                            {data.summary}
                                        </p>
                                    </div>
                                </div>

                                {/* FOOTER FIXO (Ações) */}
                                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-8 bg-white/90 dark:bg-slate-900/90 backdrop-blur-md border-t border-gray-100 dark:border-slate-800 flex gap-2 z-10 md:relative md:bg-transparent md:border-t-0">
                                    {data?.free_exemplaries?.length > 0 ? (
                                        <button
                                            onClick={() => setIsReserving(true)}
                                            className="flex-[2] py-3 bg-[#103E89] text-white font-bold text-[10px] md:text-xs uppercase tracking-widest rounded-2xl hover:bg-[#195AB4] transition-all active:scale-95 shadow-lg"
                                        >
                                            Reservar
                                        </button>
                                    ) : (
                                        <button
                                            disabled
                                            className="flex-[2] py-3 bg-slate-300 text-white font-bold text-[10px] md:text-xs uppercase tracking-widest rounded-2xl"
                                        >
                                            Indisponível
                                        </button>
                                    )}
                                    <button
                                        onClick={() => handleIndication()}
                                        className="flex-1 py-3 px-2 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-white font-black text-[10px] md:text-xs uppercase tracking-widest rounded-2xl transition-all active:scale-95"
                                    >
                                        Indicar
                                    </button>
                                    <button
                                        onClick={() => handleLike()}
                                        className={`px-4 py-3 rounded-2xl border-2 transition-all flex items-center justify-center ${likes ? 'border-red-500 text-red-500 bg-red-50' : 'border-gray-200 text-gray-400 dark:border-slate-700'}`}
                                    >
                                        {likes ? <Favorite sx={{ fontSize: 18 }} /> : <FavoriteBorder sx={{ fontSize: 18 }} />}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            /* --- VISTA 2: FORMULÁRIO DE RESERVA --- */
                            <div className="flex flex-col h-full  p-8 md:p-12 overflow-y-auto">
                                <button onClick={() => setIsReserving(false)} className="text-[#103E89] text-[10px] font-black uppercase tracking-widest flex items-center gap-2 mb-6 hover:underline">
                                    ← Voltar para Detalhes
                                </button>
                                <h2 className="text-xl lg:text-2xl font-black text-slate-800 dark:text-white mb-6">Configurar Reserva</h2>

                                <div className="space-y-4 mb-12">
                                    <div className="p-4 bg-gray-50 dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700">
                                        <label className="text-[9px] font-bold uppercase text-gray-400 block mb-2">Retirada Estimada</label>
                                        <div className="flex items-center gap-3 text-slate-700 dark:text-white font-bold">
                                            <EventAvailableOutlined className="text-[#103E89]" fontSize="small" />
                                            <input type="date" className="bg-transparent w-full outline-none text-sm" defaultValue={start} readOnly />
                                        </div>
                                    </div>
                                    <div className="p-4 bg-gray-50 dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700">
                                        <label className="text-[9px] font-bold uppercase text-gray-400 block mb-2">Prazo de Devolução</label>
                                        <div className="flex items-center gap-3 text-slate-700 dark:text-white font-bold">
                                            <CalendarMonthOutlined className="text-[#103E89]" fontSize="small" />
                                            <input type="date" className="bg-transparent w-full outline-none text-sm" defaultValue={end} readOnly />
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="bg-amber-50 dark:bg-amber-900/10 p-4 rounded-2xl mb-8">
                                    <p className="text-[10px] text-amber-700 dark:text-amber-400 leading-tight">
                                        <strong>Atenção:</strong> O livro deve ser retirado na biblioteca até as 19:00hrs do dia selecionado.
                                    </p>
                                </div> */}

                                <div className='w-full p-4 absolute bottom-0 left-0 right-0 '>
                                    <button
                                        onClick={handleSelect}
                                        className="w-full py-4 bg-[#103E89] text-white font-bold text-xs uppercase tracking-widest rounded-2xl hover:bg-[#195AB4] transition-all active:scale-95"
                                    >
                                        Confirmar Reserva
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>

        </div>
    )
}
